module.exports = __webpack_public_path__ + "static/api-docs-daf75684d2a0af10a85f76419c840e42.png";